import * as React from "react";
import { ExcludeCharacterFilterTypes } from "./Common/ExcludeCharacterFilters";

export enum AutoCompleteEnum {
  off = "off",
  chromeBrowserOff = "do-not-fill",
  on = "on",
  volledigenaam = "name",
  voornaam = "given-name",
  tweedeVoornaam = "additional-name",
  achternaam = "family-name",
  organisatie = "organization",
  adresStraat = "address-line1",
  adresStad = "address-level2",
  adresProvincie = "address-level1",
  adresPostcode = "postal-code",
  adresLandCode = "country",
  adresLand = "country-name",
  telefoonNummer = "tel",
  telefoonLandNummer = "tel-country-code",
  emailAdres = "email"
}

export interface IInputFieldProps<T = Element> {
  id?: string;
  name?: string;
  displayStyle: string;
  placeholder?: string;
  value?: string;
  onChange?: (evt: React.ChangeEvent<T>) => void | null;
  className?: string;
  input?: InputProps;
  excludeCharactersFilter?: ExcludeCharacterFilterTypes;
  autoComplete?: AutoCompleteEnum;
}

export interface InputProps {
  checked?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onBlur?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: any;
  name?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onDragStart?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onDrop?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onFocus?: any;
}
